//@flow
import * as Immutable from 'immutable';

import { GroupedGeocodeEditLocation } from 'common/models/flow/GroupedGeocodeEditLocation';
import type { GroupedGeocodeEditLocationModelType } from 'common/models/flow/GroupedGeocodeEditLocation';
import { GeocodeEditLocation } from './GeocodeEditLocation';

class InternalGroupedGeocodeEditLocation extends GroupedGeocodeEditLocation {
    static fromJS(
        json: GroupedGeocodeEditLocationModelType
    ): InternalGroupedGeocodeEditLocation {
        const state: Object = Object.assign({}, json);
        state.locations = Immutable.List(state.locations).map(item =>
            GeocodeEditLocation.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    isGroupOriginal() {
        return this.locations.every(location => location.isOriginal);
    }

    isGroupVerified() {
        return this.locations.every(location => location.verified);
    }

    isChildLocationIncluded(idsList: Array<string>) {
        return this.locations.some(location => location.isIncluded(idsList));
    }
    isEditInProgress(editingEntityIds: Array<string>) {
        return this.isChildLocationIncluded(editingEntityIds);
    }
    isVerifyInProgress(verifyingEntityIds: Array<string>) {
        return this.isChildLocationIncluded(verifyingEntityIds);
    }

    get locations(): Immutable.List<GeocodeEditLocation> {
        return this._state.get('locations');
    }
}

export { InternalGroupedGeocodeEditLocation as GroupedGeocodeEditLocation };
